import { useState } from 'react';
import { Box, Collapse, Grid, IconButton, Typography } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { HeaderField } from '../types/technicalVisit.types';

type HeaderSectionProps = {
    title: string;
    fields: HeaderField[];
};

const HeaderSection = ({ title, fields }: HeaderSectionProps) => {
    const [isExpanded, setIsExpanded] = useState(true);

    return (
        <Box sx={{ mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Typography variant="h3" sx={{ fontWeight: 600, color: '#1E272E' }}>
                    {title}
                </Typography>
                <IconButton
                    onClick={() => setIsExpanded((current) => !current)}
                    sx={{
                        width: 22,
                        height: 22,
                        ml: 1.5,
                        mt: -1.5,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.16)' }
                    }}
                >
                    {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </Box>

            <Collapse in={isExpanded}>
                <Grid container spacing={2} sx={{ pl: 2 }}>
                    {fields.map((field) => (
                        <Grid item xs={12} sm={6} md={3} lg={1.5} key={field.label}>
                            <Typography sx={{ fontWeight: 700, fontSize: 13, color: '#1E272E' }}>
                                {field.label}
                            </Typography>
                            <Typography sx={{ fontSize: 13, color: '#3f4b59' }}>
                                {field.value}
                            </Typography>
                        </Grid>
                    ))}
                </Grid>
            </Collapse>
        </Box>
    );
};

export default HeaderSection;
